"use client";

import { redirect } from "next/navigation";
import { useRouter, useSearchParams } from "next/navigation";

export default function Home() {
  // const count = useSelector((state) => state.counter.value);
  // const dispatch = useDispatch();
  const searchParams = useSearchParams();
  

  let dealerId = searchParams.get("dealer");
  let dealerLocation = searchParams.get("location");

  if (dealerId === null) {
    dealerId = "";
  }

  if (dealerLocation === null) {
    dealerLocation = "";
  }

  // const incr = () => dispatch(increment());
  // const decr = () => dispatch(decrement());

  // return <HomePage />;
  // return <Home2 />;
  redirect(`/home?dealer=${dealerId}&location=${dealerLocation}`);
  // return <QrCode />;
  // return <QrCode2 />;
  // return <QRPage />
}
